import { render, staticRenderFns } from "./DetailBarangAcc.vue?vue&type=template&id=5d2c71c6&scoped=true&"
import script from "./DetailBarangAcc.vue?vue&type=script&lang=js&"
export * from "./DetailBarangAcc.vue?vue&type=script&lang=js&"
import style0 from "./DetailBarangAcc.vue?vue&type=style&index=0&id=5d2c71c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c71c6",
  null
  
)

export default component.exports